import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		roles: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/role/all').then(data => {
				commit(types.STORE_ROLES, data);
				return data;
			})
		},
		
		fetchRoleUsers({ commit }, { id }) {
			return axios.get(`/role/${id}/users`)
		},

		fetchById({ commit }, { id }) {
			return axios.get(`/role/${id}`)
		},

		create({ commit }, { name, parentId, rolePermissions }) {
			return axios.post('/role', { name, parentId, rolePermissions })
		},

		update({ commit }, { id, name, parentId, rolePermissions }) {
			return axios.put(`/role/${id}`, { name, parentId, rolePermissions })
		},

		delete({ commit }, { id }) {
			return axios.delete(`/role/${id}`)
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_ROLES](state, roles) {
			state.roles = roles;
		},
		[types.RESET](state) {
			state.roles = [];
		}
	},

	getters: {
		getRoleById: state => id => state.roles.find(c => c.id === id)
	}
}